/* unplugin-vue-components disabled */import script from "./anchorlinks.vue?vue&type=script&lang=js"
export * from "./anchorlinks.vue?vue&type=script&lang=js"

import "./anchorlinks.vue?vue&type=style&index=0&id=5b4d3a38&lang=scss"

const __exports__ = script;

export default __exports__